import { Route, Routes } from "react-router-dom";
import SlaMetricsPage from "../../app/sla-metrics";

export default function SlaMetricsRoutes() {
  return (
    <Routes>
      <Route path="*" element={<SlaMetricsPage />} />
    </Routes>
  );
}
